import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';
import JobsList from './components/jobs/JobsList';
import JobDetails from './components/jobs/JobDetails';
import PostJob from './components/jobs/PostJob';
import EditJob from './components/jobs/EditJob';
import JobBoards from './components/jobs/TodoList';
import AdminDashboard from './components/admin/AdminDashboard';
import CompanyList from './components/companies/CompanyList';
import AddCompany from './components/companies/AddCompany';
import EditCompany from './components/companies/EditCompany';
import JobSeekerList from './components/jobseekers/JobSeekerList';
import AddJobSeeker from './components/jobseekers/AddJobSeeker';
import EditJobSeeker from './components/jobseekers/EditJobSeeker';
import Login from './pages/Login';
import SkillsList from './components/skills/SkillsList';
import AddSkill from './components/skills/AddSkill';
import EditSkill from './components/skills/EditSkill';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/admin" replace />} />
          
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              
              {/* Jobs Routes */}
              <Route path="/admin/jobs" element={<JobsList />} />
              <Route path="/admin/jobs/new" element={<PostJob />} />
              <Route path="/admin/jobs/:id" element={<JobDetails />} />
              <Route path="/admin/jobs/:id/edit" element={<EditJob />} />
              
              {/* Companies Routes */}
              <Route path="/admin/companies" element={<CompanyList />} />
              <Route path="/admin/companies/new" element={<AddCompany />} />
              <Route path="/admin/companies/:id/edit" element={<EditCompany />} />
              
              {/* Job Seekers Routes */}
              <Route path="/admin/job-seekers" element={<JobSeekerList />} />
              <Route path="/admin/job-seekers/new" element={<AddJobSeeker />} />
              <Route path="/admin/job-seekers/:id/edit" element={<EditJobSeeker />} />
              
              {/* Skills Routes */}
              <Route path="/admin/skills" element={<SkillsList />} />
              <Route path="/admin/skills/new" element={<AddSkill />} />
              <Route path="/admin/skills/:id/edit" element={<EditSkill />} />
              
              {/* Settings Routes */}
              <Route path="/admin/todo-lists" element={<JobBoards />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
